import colorPallete, { bodyFonts, headlineFonts, labelFonts } from "@DSG/MobiusOverrides/styles/variables";
import Zone from "@insite/client-framework/Components/Zone";
import {
    ExcludeFromNavigation,
    ExcludeFromSignInRequired,
    HideFooter,
    HideHeader,
    MetaDescription,
    MetaKeywords,
    OpenGraphImage,
    OpenGraphTitle,
    OpenGraphUrl,
        
} from "@insite/client-framework/Types/FieldDefinition";
import PageModule from "@insite/client-framework/Types/PageModule";
import PageProps from "@insite/client-framework/Types/PageProps";
import Modals from "@insite/content-library/Components/Modals";
import Page, { PageProps as MobiusPageProps } from "@insite/mobius/Page";
import { BaseTheme } from "@insite/mobius/globals/baseTheme";
import breakpointMediaQueries from "@insite/mobius/utilities/breakpointMediaQueries";
import React from "react";
import { css } from "styled-components";


export interface DsgCustomPageStyles {
    page?: MobiusPageProps;
}

export const dsgCustomPageStyles: DsgCustomPageStyles = {
    page: {
        css: css`
            .threeColumnStep {
                [class*="LazyImageStyle"] {
                    padding: 0 !important;
                }
            }   
            .dsgRewardMemberInnerWrapper {
                > div {
                    row-gap: 40px;
                }
            }
            .contentWrapper {
                display: flex;
                row-gap: 24px;
                flex-direction: column;
            }
            .dsgRewardMemberSection {
                border: 1px solid ${colorPallete.grey500};
                padding: 24px;
                border-radius: 8px;
                margin-bottom: 80px !important;
            }
            .howToTrackEarningsSection {
                border: 1px solid ${colorPallete.grey500};
                padding: 40px 24px;
                border-radius: 8px;
                .dsgCustomPageBtnWrapper {
                    padding-top: 40px;
                }
            }
            .bodyTextSmall {
                font: ${labelFonts.label1Regular.fontWeight} ${labelFonts.label1Regular.fontSize}/${labelFonts.label1Regular.lineHeight} ${labelFonts.label1Regular.fontFamily};
                color: ${colorPallete.grey800};
                strong {
                    font-weight: 600;
                }
            }
            .bodyTextLarge {
                font: ${headlineFonts.headline5RegularSm.fontWeight} ${headlineFonts.headline5RegularSm.fontSize}/${headlineFonts.headline5RegularSm.lineHeight} ${headlineFonts.headline5RegularSm.fontFamily};
                color: ${colorPallete.grey800};
            }
            .body2Text {
                font: ${bodyFonts.body2RegularSm.fontWeight} ${bodyFonts.body2RegularSm.fontSize}/${bodyFonts.body2RegularSm.lineHeight} ${bodyFonts.body2RegularSm.fontFamily};
                color: ${colorPallete.grey800};
            }
            .body1Text {
                font: ${bodyFonts.body1RegularSm.fontWeight} ${bodyFonts.body1RegularSm.fontSize}/${bodyFonts.body1RegularSm.lineHeight} ${bodyFonts.body1RegularSm.fontFamily};
                color: ${colorPallete.grey800};
            }
            .dsgCustomPageBtnWrapper {
                .dsgBtn {
                    min-width: 278px;
                    padding-top: 4px;
                    padding-bottom: 4px;
                    &:after {
                        display: inline-block;
                        position: relative;
                        top: -1px;
                        margin-left: 8px;
                        height: 24px;
                    }
                }
            }
            .dsgPlusTwoColumnWrapper {
                > div {
                    > div > div {
                        > div {
                            margin-bottom: 8px;
                        }
                    }
                }
            }
            .threeColumnStep {
                h4 {
                    font: ${headlineFonts.headline4SemiBoldSm.fontWeight} ${headlineFonts.headline4SemiBoldSm.fontSize}/${headlineFonts.headline4SemiBoldSm.lineHeight} ${headlineFonts.headline4SemiBoldSm.fontFamily};
                    color: ${colorPallete.grey800};
                }
            }
            .contentCenter {
                text-align: center;
            }
            .headingContent {
                max-width: 1062px;
                margin-left: auto;
                margin-right: auto;
                h3 {
                    font: ${headlineFonts.headline2SemiBoldSm.fontWeight} ${headlineFonts.headline2SemiBoldSm.fontSize}/${headlineFonts.headline2SemiBoldSm.lineHeight} ${headlineFonts.headline2SemiBoldSm.fontFamily};
                    color: ${colorPallete.grey800};
                    margin-bottom: 8px;
                }
                p {
                    font: ${bodyFonts.body1RegularSm.fontWeight} ${bodyFonts.body1RegularSm.fontSize}/${bodyFonts.body1RegularSm.lineHeight} ${bodyFonts.body1RegularSm.fontFamily};
                    color: ${colorPallete.grey800};
                    margin-bottom: 0;
                }
            }
            .threeColumnStep {
                padding: 40px 48px 80px;;
                > div {
                    row-gap: 40px;
                    > div {
                        &:not(:last-child) {
                            padding-bottom: 40px;
                            border-bottom: 1px solid ${colorPallete.grey500};
                        }
                    }
                }
            }
            .howToEarnRewardsSection {
                .threeColumnStep {
                    [class*="LazyImageStyle"] {
                        max-height: 56px;
                        display: block !important;
                        img {
                            max-height: 56px;
                        }
                    }
                }
                [class*="LazyImageStyle"] {
                    margin-bottom: 24px;
                }
                h4 {
                    margin-bottom: 8px;
                }
                .bodyTextLarge {
                    margin-bottom: 24px;
                }
                .body2Text {
                    margin-top: 24px;
                }
                .bodyTextSmall {
                    margin-bottom: 8px;
                    &:last-child {
                        margin-bottom: 0;
                    }
                    strong {
                        display: block;
                    }
                }
            }
            .howToEnrollSection {
                .threeColumnStep {
                    [class*="LazyImageStyle"] {
                        max-height: 48px;
                        img {
                            max-height: 48px;
                        }
                    }
                    [class*="ContentWrapper"] {
                        display: flex;
                        row-gap: 16px;
                        flex-direction: column;
                    }
                    h4 {
                        margin-bottom: 0;
                    }
                }
            }
            .requestDsgPlusFormSection {
                > div {
                    max-width: 846px;
                    margin: auto;
                }
                h3 {
                    margin-bottom: 40px;
                }
            }
            .horizontalLine {
                hr {
                    margin-bottom: 40px;
                    margin-top: 0;
                    border: none;
                    border-top: 1px solid ${colorPallete.grey500};
                }
            }
            ${({ theme }: { theme: BaseTheme }) =>
            breakpointMediaQueries(
                theme,
                [
                    null,
                    null,
                    css`
                        .dsgRewardMemberInnerWrapper {
                            > div > div {
                                &:first-child {
                                    padding-right: 20px;
                                }
                                &:last-child {
                                    padding-left: 20px;
                                }
                            }
                        }
                        .dsgPlusTwoColumnWrapper {
                            > div {
                                > div > div {
                                    > div {
                                        margin-bottom: 16px;
                                    }
                                }
                            }
                        }
                        .threeColumnStep {
                            padding: 80px 0 48px;
                            > div {
                                row-gap: 0;
                                flex-wrap: initial;
                                > div {
                                    &:not(:last-child) {
                                        padding-bottom: 0;
                                        border-right: 1px solid ${colorPallete.grey500};
                                        border-bottom: none;
                                    }
                                    &:nth-child(2) {
                                        margin-left: 24px;
                                        padding-right: 24px;
                                    }
                                    &:first-child {
                                        padding-right: 24px;
                                    }
                                    &:last-child {
                                        padding-left: 24px;
                                    }
                                }
                            }
                            h4 {
                                font-size: ${headlineFonts.headline4SemiBoldLg.fontSize};
                                line-height: ${headlineFonts.headline4SemiBoldLg.lineHeight};
                            }
                        }

                        .horizontalLine {
                            hr {
                                margin-bottom: 48px;
                            }
                        }
                        .bodyTextLarge {
                            font-size: ${bodyFonts.body1RegularLg.fontSize};
                            line-height: ${bodyFonts.body1RegularLg.lineHeight};
                        }
                        .body1Text {
                            font-size: ${bodyFonts.body1RegularLg.fontSize};
                            line-height: ${bodyFonts.body1RegularLg.lineHeight};
                        }
                        .howToEarnRewardsSection  {
                            .bodyTextSmall {
                                strong {
                                    display: inline-block;
                                }
                            }
                        }
                        .dsgRewardMemberSection {
                            margin-bottom: 48px !important;
                        }
                        .threeColumnStep {
                            .body2Text {
                                font-size: ${bodyFonts.body2RegularLg.fontSize};
                                line-height: ${bodyFonts.body2RegularLg.lineHeight};
                            }
                        }
                        .headingContent {
                            h3 {
                                font-size: ${headlineFonts.headline2SemiBoldLg.fontSize};
                                line-height: ${headlineFonts.headline2SemiBoldLg.lineHeight}
                            }
                            p {
                                font-size: ${bodyFonts.body1RegularLg.fontSize};
                                line-height: ${bodyFonts.body1RegularLg.lineHeight}
                            }
                        }
                    `,
                    css`
                        .dsgRewardMemberSection {
                            padding: 40px;
                        }
                        .howToTrackEarningsSection {
                            padding: 80px;
                            margin-top: 48px !important;
                        }
                        .dsgPlusTwoColumnWrapper {
                            padding-top: 0;
                        }
                        .threeColumnStep {
                            > div {
                                > div {
                                    &:nth-child(2) {
                                        margin-left: 64px;
                                        padding-right: 64px;
                                    }
                                    &:first-child {
                                        padding-right: 64px;
                                    }
                                    &:last-child {
                                        padding-left: 64px;
                                    }
                                }
                            }
                        }
                    `,
                ],
                "min",
            )}
          
            ${({ theme }: { theme: BaseTheme }) =>
            breakpointMediaQueries(
                theme,
                [
                    null,
                    null,
                    css`
                        .howToEnrollSection,
                        .howToEarnRewardsSection {
                            .threeColumnStep {
                                max-height: 40px
                                [class*="LazyImageStyle"] img {
                                    max-height: 40px
                                }
                            }
                        }
                    `,
                ],
                "minMax",
            )}
        `
    },
}
const styles = dsgCustomPageStyles;
const DsgCustomPage = ({ id, fields }: PageProps) => {
    return(
    <Page {...styles.page}>
        <Zone contentId={id} zoneName="Content"></Zone>
       <Zone contentId={id} zoneName="firstContainerFluidContent"></Zone>
        <Zone contentId={id} zoneName="firstContainerContent"></Zone>
        <Zone contentId={id} zoneName="secondContainerFluidContent"></Zone>
        <Zone contentId={id} zoneName="secondContainerContent"></Zone>
        <Modals />
    </Page>
    );
    
};

const pageModule: PageModule = {
    component: DsgCustomPage,
    definition: {
        hasEditableUrlSegment: true,
        hasEditableTitle: true,
        pageType: "Content",
        fieldDefinitions: [
            MetaKeywords,
            MetaDescription,
            OpenGraphTitle,
            OpenGraphUrl,
            OpenGraphImage,
            HideHeader,
            HideFooter,
            ExcludeFromNavigation,
            ExcludeFromSignInRequired,
            {
                name: "overrideTitle",
                displayName:"Override Title",
                defaultValue: "",
                editorTemplate: "TextField",
                fieldType: "Translatable",
            },
        ],
    },
};

export default pageModule;
